import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { UserId } from "@@/shared/users/user-id";
import { isUserId } from "@@/shared/users/user-id";
import type { Order } from "../order";
import type {
    OrderSocketEventBase} from "./order-socket-event-base";
import {
    createOrderSocketEventBase
} from "./order-socket-event-base";
import { createOrderSocketEventData } from "./order-socket-event-data";
import type { OrderSocketEventTypeName } from "./order-socket-event-type-name";

type TypeName = Extract<OrderSocketEventTypeName, "pending_delivery">;
type EventData = {
    pendingDeliveryAt: IsoAndUnixTimestamp | undefined;
};
type OrderPendingDeliverySocketEvent = OrderSocketEventBase<
    TypeName,
    EventData
>;

const createOrderPendingDeliverySocketEvent = (params: {
    order: Order;
    triggeredBy: UserId;
    triggeredAt: IsoAndUnixTimestamp;
}): OrderPendingDeliverySocketEvent => {
    const { order, triggeredAt, triggeredBy } = params;
    return createOrderSocketEventBase<TypeName, EventData>({
        for: [
            order.providerId,
            order.orderGroupId,
            order._id,
            ...(isUserId(order.customerId) ? [order.customerId] : []),
        ],
        type: "order:pending_delivery",
        triggeredAt,
        triggeredBy,
        data: createOrderSocketEventData<EventData>({
            order,
            triggeredBy,
            data: {
                pendingDeliveryAt: order.delivery.estimatedDeliveryTime,
            },
        }),
    });
};
export { createOrderPendingDeliverySocketEvent };
export type { OrderPendingDeliverySocketEvent };
